import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import OpenInNewIcon from '@material-ui/icons/OpenInNew';
export const _frontmatter = {
  "title": "Plain Language",
  "layout": "content",
  "includeToc": true,
  "permalink": "/plain-language/"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "Plain-Language",
      "style": {
        "position": "relative"
      }
    }}>{`Plain Language`}</h1>
    <p>{`Plain language makes it easier for the public to read, understand and use government communications. `}</p>
    <h2 {...{
      "id": "Plain-Language-Writing-Act-of-2010",
      "style": {
        "position": "relative"
      }
    }}>{`Plain Language Writing Act of 2010`}</h2>
    <p>{`The purpose of the `}<a parentName="p" {...{
        "href": "https://www.govinfo.gov/content/pkg/BILLS-111hr946enr/pdf/BILLS-111hr946enr.pdf"
      }}>{`Plain Writing Act of 2010 (PDF) `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{` is “to improve the effectiveness and accountability of federal agencies to the public by promoting clear government communication that the public can understand and use.” This law changed how the government communicates with the public and all government agencies are expected to follow the requirements outlined in this regulation. `}</p>
    <h2 {...{
      "id": "Our-Commitment",
      "style": {
        "position": "relative"
      }
    }}>{`Our Commitment`}</h2>
    <p>{`Many aspects of the Department of Interior's programs and operations have a direct impact on the public, and it is vital that we communicate clearly and reliably. To learn how we’re implementing the Plain Writing Act, read our `}<a parentName="p" {...{
        "href": "https://www.doi.gov/plainlanguage/plain-writing-act"
      }}>{`plain writing implementation plan `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{`. At ONRR, we are committed to: `}</p>
    <ul>
      <li parentName="ul">{`Writing in plain language. `}</li>
      <li parentName="ul">{`Using the `}<a parentName="li" {...{
          "href": "https://www.plainlanguage.gov/guidelines/"
        }}>{`Federal Plain Language Guidelines `}<OpenInNewIcon style={{
            fontSize: 20
          }} mdxType="OpenInNewIcon" /></a>{`.  `}</li>
      <li parentName="ul">{`Training our employees. `}</li>
      <li parentName="ul">{`Strengthening our oversight process. `}</li>
      <li parentName="ul">{`Promoting plain language across the Department. `}</li>
    </ul>
    <h2 {...{
      "id": "Documents-Required-to-be-in-Plain-Language",
      "style": {
        "position": "relative"
      }
    }}>{`Documents Required to be in Plain Language`}</h2>
    <p>{`At ONRR, we will use plain language in any document that: `}</p>
    <ul>
      <li parentName="ul">{`Is necessary for obtaining any federal government benefit or service or filing taxes. `}</li>
      <li parentName="ul">{`Provides information about any federal government benefit or service. `}</li>
      <li parentName="ul">{`Explains to the public how to comply with a requirement that the federal government administers or enforces. `}</li>
    </ul>
    <p>{`The following types of documents are required to be in plain language: `}</p>
    <ul>
      <li parentName="ul">{`Publications `}</li>
      <li parentName="ul">{`Instructions `}</li>
      <li parentName="ul">{`Applications `}</li>
      <li parentName="ul">{`Technical reports `}</li>
      <li parentName="ul">{`News releases `}</li>
      <li parentName="ul">{`Webpages `}</li>
      <li parentName="ul">{`General correspondence with the public (both paper and electronic format) `}</li>
      <li parentName="ul">{`Vacancy announcements and instructions on how to apply for jobs `}</li>
    </ul>
    <h2 {...{
      "id": "Departmental-Compliance-Reports",
      "style": {
        "position": "relative"
      }
    }}>{`Departmental Compliance Reports`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.doi.gov/sites/doi.gov/files/plain-language-report-august-2022.pdf"
        }}>{`August 2022 (PDF) `}<OpenInNewIcon style={{
            fontSize: 20
          }} mdxType="OpenInNewIcon" /></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.doi.gov/sites/doi.gov/files/doi-plain-writing-act-compliance-report-august-2021.pdf"
        }}>{`August 2021 (PDF) `}<OpenInNewIcon style={{
            fontSize: 20
          }} mdxType="OpenInNewIcon" /></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.doi.gov/plainlanguage/past-plain-language-compliance-reports"
        }}>{`Past Plain Language Compliance Reports `}<OpenInNewIcon style={{
            fontSize: 20
          }} mdxType="OpenInNewIcon" /></a></li>
    </ul>
    <h2 {...{
      "id": "Contact-Us",
      "style": {
        "position": "relative"
      }
    }}>{`Contact Us`}</h2>
    <p>{`We continue to look for ways to improve our work and would like to hear your feedback. Please contact us at `}<a parentName="p" {...{
        "href": "mailto:nrrd@onrr.gov"
      }}>{`nrrd@onrr.gov`}</a>{`.`}</p>
    <h2 {...{
      "id": "Plain-Language-Resources",
      "style": {
        "position": "relative"
      }
    }}>{`Plain Language Resources`}</h2>
    <h3 {...{
      "id": "Guidance",
      "style": {
        "position": "relative"
      }
    }}>{`Guidance`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.plainlanguage.gov/guidelines/"
        }}>{`Plain Writing Guidelines `}<OpenInNewIcon style={{
            fontSize: 20
          }} mdxType="OpenInNewIcon" /></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.plainlanguage.gov/about/definitions/"
        }}>{`Frequently Asked Questions `}<OpenInNewIcon style={{
            fontSize: 20
          }} mdxType="OpenInNewIcon" /></a>{`  `}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.plainlanguage.gov/resources/checklists/checklist/"
        }}>{`Checklist for Plain Language `}<OpenInNewIcon style={{
            fontSize: 20
          }} mdxType="OpenInNewIcon" /></a>{` `}</li>
    </ul>
    <h3 {...{
      "id": "Trainings",
      "style": {
        "position": "relative"
      }
    }}>{`Trainings`}</h3>
    <p>{`The Plain Writing Act requires agencies to train their staff in plain language. The Department offers training to our employees through `}<a parentName="p" {...{
        "href": "https://doiu.doi.gov/catalog"
      }}>{`DOI University `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{` and `}<a parentName="p" {...{
        "href": "https://doitalent.ibc.doi.gov/"
      }}>{`DOI Talent `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{`. `}</p>
    <br />
    <p>{`For additional training, we recommend: `}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.plainlanguage.gov/training/online-training/"
        }}>{`Online training from plainlanguage.gov `}<OpenInNewIcon style={{
            fontSize: 20
          }} mdxType="OpenInNewIcon" />{`.`}</a>{` This page provides links to plain language training resources, including workshops and toolkits. `}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.youtube.com/playlist?list=PLd9b-GuOJ3nHMlmPFMw8cJxN_DW-odj0J"
        }}>{`Training videos (YouTube) `}<OpenInNewIcon style={{
            fontSize: 20
          }} mdxType="OpenInNewIcon" /></a>{` from the Plain Language Action and Information Network (PLAIN).`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      